export default __webpack_public_path__ + "static/media/gift-cards.4db6de10.webp";